import { useState, useEffect } from "react";

const QUOTES = [
  { text: "Achetez la terre, on n'en fait plus.", author: "Mark Twain" },
  { text: "L'immobilier ne peut être perdu, ni emporté.", author: "Franklin D. Roosevelt" },
  { text: "Le risque vient du fait de ne pas savoir ce que l'on fait.", author: "Warren Buffett" },
  { text: "L'immobilier, c'est l'art de transformer le temps en patrimoine.", author: "Odys'Invest" },
  { text: "Le meilleur moment pour planter un arbre était il y a 20 ans. Le second meilleur est maintenant.", author: "Proverbe chinois" },
  { text: "Un investisseur intelligent vend à des optimistes et achète à des pessimistes.", author: "Benjamin Graham" },
  { text: "La patience est la clé de tout investissement réussi.", author: "Warren Buffett" },
  { text: "Construire un patrimoine, c'est bâtir l'avenir de sa famille.", author: "Odys'Invest" },
];

export default function SplashLoader({ onComplete }) {
  const [quote] = useState(() => QUOTES[Math.floor(Math.random() * QUOTES.length)]);

  useEffect(() => {
    // Progress bar runs via CSS animation (2.2s) — schedule onComplete just after
    const timer = setTimeout(() => onComplete?.(), 2400);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="splash-loader-dossier" data-testid="splash-loader">
      {/* Ornement central avec logo boussole */}
      <div className="splash-ornament">
        <svg className="splash-ornament-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" stroke="#B5894A" strokeWidth="1.2">
            <circle cx="50" cy="50" r="46" strokeDasharray="3 5" opacity="0.85" />
            <circle cx="50" cy="50" r="36" strokeDasharray="2 6" opacity="0.5" />
            <path
              d="M50 18 L54 46 L82 50 L54 54 L50 82 L46 54 L18 50 L46 46 Z"
              fill="#B5894A"
              opacity="0.55"
            />
          </g>
        </svg>
        <div className="splash-ornament-ring" />
        <div className="splash-logo-disc">
          <img
            src="/logo-boussole.png"
            alt="Odys'Mentoring"
            className="splash-logo-img"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        </div>
      </div>

      {/* Titre + filet or + citation */}
      <div className="splash-text-block">
        <h1 className="splash-title-dossier">
          Odys'<span>Mentoring</span>
        </h1>
        <div className="splash-gold-line" />
        <p className="splash-quote-dossier">« {quote.text} »</p>
        <p className="splash-author-dossier">— {quote.author}</p>
      </div>

      {/* Barre de progression */}
      <div className="splash-progress-track">
        <div className="splash-progress-fill" />
      </div>

      <style>{`
        .splash-loader-dossier {
          position: fixed;
          inset: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #FAF7F1;
          background-image:
            radial-gradient(circle at 50% 30%, rgba(181, 137, 74, 0.06) 0%, transparent 55%),
            radial-gradient(circle at 1px 1px, rgba(181, 137, 74, 0.04) 1px, transparent 1px);
          background-size: 100% 100%, 6px 6px;
          font-family: Georgia, 'Times New Roman', serif;
          z-index: 9999;
        }

        .splash-ornament {
          position: relative;
          width: 160px;
          height: 160px;
          margin-bottom: 36px;
        }

        .splash-ornament-svg {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          animation: ornament-rotate-slow 7s linear infinite;
        }

        .splash-ornament-ring {
          position: absolute;
          inset: 22px;
          border: 2px solid #E9DCC4;
          border-top-color: #B5894A;
          border-radius: 50%;
          animation: ornament-rotate-slow 1.4s linear infinite reverse;
        }

        .splash-logo-disc {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #FFFFFF;
          width: 78px;
          height: 78px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow:
            0 6px 22px rgba(40, 28, 18, 0.18),
            0 0 0 2px #B5894A,
            inset 0 0 0 4px #FAF7F1;
          padding: 14px;
          z-index: 10;
        }

        .splash-logo-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          animation: logoBreath 3s ease-in-out infinite;
        }

        @keyframes ornament-rotate-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes logoBreath {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.06); }
        }

        .splash-text-block {
          text-align: center;
          max-width: 520px;
          padding: 0 24px;
        }

        .splash-title-dossier {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 30px;
          font-weight: 700;
          color: #16233B;
          margin: 0 0 6px;
          letter-spacing: -0.005em;
        }

        .splash-title-dossier span {
          color: #B5894A;
        }

        .splash-gold-line {
          width: 64px;
          height: 2px;
          background: linear-gradient(90deg, transparent, #B5894A, transparent);
          margin: 0 auto 22px;
          border-radius: 2px;
        }

        .splash-quote-dossier {
          font-family: Georgia, 'Times New Roman', serif;
          font-style: italic;
          font-size: 15px;
          line-height: 1.6;
          color: #3C4A63;
          margin: 0;
          min-height: 50px;
          opacity: 0;
          animation: quoteFadeIn 0.7s ease 0.3s forwards;
        }

        .splash-author-dossier {
          font-family: 'Inter', -apple-system, sans-serif;
          font-size: 11px;
          font-weight: 600;
          color: #8C6635;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          font-style: normal;
          margin: 14px 0 0;
          opacity: 0;
          animation: quoteFadeIn 0.7s ease 0.5s forwards;
        }

        @keyframes quoteFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .splash-progress-track {
          width: 280px;
          height: 4px;
          background: #F3EEE4;
          border: 1px solid #E9DCC4;
          border-radius: 9999px;
          overflow: hidden;
          margin-top: 36px;
        }

        .splash-progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #B5894A, #8C6635);
          border-radius: 9999px;
          width: 0%;
          animation: progressLoad 2.2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }

        @keyframes progressLoad {
          0%   { width: 0%; }
          20%  { width: 25%; }
          60%  { width: 70%; }
          100% { width: 100%; }
        }
      `}</style>
    </div>
  );
}
